<template>
    <div id="single_plan_finish_chart" style="height: 100%"></div>
</template>

<script>
import {_pxGenerator} from "../../../../../LayoutMaps/maps/MapFunction";
import * as echarts from 'echarts'

export default {
    name: "SingleInspectionQualifyChart",
    data() {
        return {
            chart: {},
            fs: 0.12,
            option: {},
            xAxis: ['定子', '缸体', '转子', '核心组装', '动平衡', '设备成套', '试验中心'],
            rates: [99.9, 98.4, 99.8, 99.8, 100, 100, 100],
            min: 95,
            max: 100
        };
    },
    mounted() {
        this.setOption()
        this.loadChart()
        window.addEventListener('resize', this.handle, false)
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handle, false)
    },
    methods: {
        handle() {
            this.loadChart()
            this.chart.resize()
        },
        loadChart() {
            this.chart = echarts.init(document.getElementById('single_plan_finish_chart'));
            this.chart.setOption(this.option);
        },
        setOption() {
            this.option = {
                title: {
                    text: '一次检验合格率YTD',
                    textStyle: {
                        color: '#fff',
                        fontSize: _pxGenerator(0.16)
                    },
                    top: '10%',
                    right: '10%'
                },
                grid: {
                    bottom: '10%',
                    top: '20%'
                },
                xAxis: {
                    type: 'category',
                    data: this.xAxis,
                    axisTick: {
                        show: false
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#fff'
                        }
                    },
                    axisLabel: {
                        margin: _pxGenerator(0.04),
                        fontSize: _pxGenerator(this.fs),
                        rotate: 30
                    }
                },
                yAxis: {
                    type: "value",
                    name: "FTY/%",
                    nameTextStyle: {
                        fontSize: _pxGenerator(this.fs)
                    },
                    axisLabel: {
                        fontSize: _pxGenerator(this.fs),
                        margin: _pxGenerator(0.02)
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#fff'
                        }
                    },
                    splitLine: {
                        lineStyle: {
                            color: '#575665'
                        }
                    },
                    axisTick: {
                        show: false
                    },
                    min: this.min,
                    max: this.max
                },
                series: [
                    {
                        name: "合格率",
                        data: this.rates,
                        type: "bar",
                        color: "rgba(55, 162, 218, 1)",
                        label: {
                            show: true,
                            color: '#fff',
                            position: 'insideTop',
                            formatter: '{c}%',
                            fontSize: _pxGenerator(this.fs)
                        },
                        showBackground: true,
                        backgroundStyle: {
                            color: 'rgba(55, 162, 218, 0.2)'
                        },
                    }
                ]
            }
        }
    }
}
</script>

<style scoped>

</style>